import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import { Breadcrumb } from "./Breadcrumb";
import "../scss/breadcrumbs.scss";
export { Breadcrumb };

var stringify = function stringify(data) {
  if (process.env.NODE_ENV === "production") return JSON.stringify(data);
  return JSON.stringify(data, null, 2);
};

var getBreadcrumbJsonLdItem = function getBreadcrumbJsonLdItem(breadcrumb, index) {
  if (index === void 0) {
    index = 0;
  }

  return {
    "@type": "ListItem",
    position: index + 1,
    item: {
      "@id": breadcrumb.props.to,
      name: breadcrumb.props.children
    }
  };
};

export var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var jsonLdData = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: children.length ? children.filter(Boolean).map(getBreadcrumbJsonLdItem) : getBreadcrumbJsonLdItem(children)
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "Breadcrumbs",
    role: "navigation"
  }, rest), /*#__PURE__*/React.createElement("ol", {
    className: "breadcrumbs"
  }, children)), /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: stringify(jsonLdData)
    }
  }));
};